import { useNavigate } from "react-router-dom";
import { useIntercom } from "react-use-intercom";
import { CircularProgress } from "@mui/material";

import PrimaryButton from "../../Components/Buttons/primary-button.js";
import CardButton from "../../Components/Buttons/card-button";

import renderColoradoRenterRewards from "../../Organisms/Modals/Programs/colorado-renter-rewards";

import { useAppEssentials, usePrograms } from "../../CustomHooks/Queries";
import { useLogout } from "../../CustomHooks/Mutations";

import { useModalContext } from "../../Contexts/ModalContext.js";

import { onSignOut } from "../../Utils/helpers.js";

import {
  Disclosures,
  Terms,
  Privacy,
  ProfileOutline,
  SupportThin,
  Out,
  CircleQuestionThin,
  ArrowLeftCircle,
} from "../../Assets/Icons";

import "./profile.scss";
import "./profile-responsive.scss";

export default function Profile() {
  const navigate = useNavigate();

  const modalContext = useModalContext();

  const { show: showIntercom } = useIntercom();

  const { isLoading: isLoadingAppEssentials, data: appEssentialsData } = useAppEssentials();
  const { isLoading: isLoadingPrograms, data: programs } = usePrograms({
    enabled: appEssentialsData?.propertyHasProgram ?? false,
  });

  const { mutate: InitLogout } = useLogout({
    onSettled: onSignOut,
  });

  const handleLearnMoreClick = () => {
    if (programs?.my_program?.id === "colorado_renter_rewards") {
      renderColoradoRenterRewards(modalContext, {
        skipProgramIntro: true,
      });
    }
  };

  const isLoading = isLoadingAppEssentials || isLoadingPrograms;

  return (
    <div className="profile">
      <section className="card-section-wrapper">
        <div className="max-width-container">
          <div className="card-section">
            <div className="section-header justify-content-start">
              <button className="go-back-button" onClick={navigate.bind(this, -1)}>
                <ArrowLeftCircle />
              </button>
              <h3 className="section-title">Profile</h3>
            </div>
            {isLoading ? (
              <div className="loading-content">
                <CircularProgress />
              </div>
            ) : (
              <>
                {!!programs?.my_program && (
                  <div className="program-info-card mb-sm-5 mb-3">
                    <div className="program-content">
                      <img
                        src={programs?.my_program?.image_src?.primary}
                        alt={programs?.my_program?.name}
                        className="program-logo"
                      />
                      <h4 className="program-title">You're eligible for {programs?.my_program?.name} program.</h4>
                      <p className="program-description">{programs?.my_program?.property_benefit_briefing}</p>
                      <PrimaryButton className="dark-theme" onClick={handleLearnMoreClick}>
                        Learn More
                      </PrimaryButton>
                    </div>
                  </div>
                )}
                <div className="text-lg-semibold color--mist mb-sm-5 mb-3">Account</div>
                <div className="mb-sm-5 mb-3">
                  <CardButton
                    title="Personal Information"
                    Icon={ProfileOutline}
                    onClick={navigate.bind(this, "/profile/personal-information")}
                  />
                </div>
                <div className="text-lg-semibold color--mist mb-sm-5 mb-3">Support</div>
                <div className="mb-sm-5 mb-3">
                  <CardButton title="Contact Support" Icon={SupportThin} onClick={showIntercom} />
                </div>
                <div className="mb-sm-5 mb-3">
                  <CardButton
                    title="FAQ"
                    Icon={CircleQuestionThin}
                    onClick={window.open.bind(this, "https://www.stake.rent/faq", "_blank")}
                  />
                </div>
                <div className="text-lg-semibold color--mist mb-sm-5 mb-3">Agreement</div>
                <div className="mb-sm-5 mb-3">
                  <CardButton
                    title="Terms"
                    Icon={Terms}
                    onClick={window.open.bind(this, "https://www.stake.rent/legal/terms-of-use", "_blank")}
                  />
                </div>
                <div className="mb-sm-5 mb-3">
                  <CardButton
                    title="Disclosure"
                    Icon={Disclosures}
                    onClick={window.open.bind(this, "https://www.stake.rent/disclosure", "_blank")}
                  />
                </div>
                <div className="mb-sm-5 mb-3">
                  <CardButton
                    title="Privacy"
                    Icon={Privacy}
                    onClick={window.open.bind(this, "https://www.stake.rent/legal/privacy-policy", "_blank")}
                  />
                </div>
                <div className="mb-sm-5 mb-3">
                  <CardButton className="logout" title="Logout" Icon={Out} onClick={InitLogout} />
                </div>
              </>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
